module.exports = __webpack_public_path__ + "static/media/money.4c5b98fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/imgs/money.png
// module id = 1171
// module chunks = 0